import Button from "@joinTrilo/ui/atoms/Button/Button";
import Tab from "@joinTrilo/ui/atoms/Tab";
import { useCallback, useState } from "react";
import { useAuth } from "src/hooks/context";
import { useAddEmailToPayment } from "src/hooks/useAddEmailToPayment";
import { StyledFormContainer, StyledFormWrapper } from "../Auth/Auth.styled";
import { Email } from "../Auth/Email";
import { StyledFormResponseStatus } from "./Receipt.styled";

export const Receipt = ({ agreementId }: { agreementId: string }) => {
    const { authState } = useAuth();
    const [email, setEmail] = useState<string | undefined>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [receiptRequestStatus, setReceiptRequestStatus] = useState<
        boolean | null
    >(null);
    const { addEmailToPayment } = useAddEmailToPayment();

    const submitEmailForReceipt = useCallback(async () => {
        if (!email || email === null) {
            return;
        }
        setIsLoading(true);
        const result = await addEmailToPayment({ email, agreementId });
        console.log("[Receipt] addEmailToPayment", result);
        setIsLoading(false);
        setReceiptRequestStatus(result);
    }, [
        email,
        setIsLoading,
        setReceiptRequestStatus,
        addEmailToPayment,
        agreementId,
    ]);

    if (authState && authState.isLoggedIn === false) {
        return (
            <>
                <StyledFormContainer display={"true"}>
                    {receiptRequestStatus !== null && (
                        <StyledFormResponseStatus>
                            {receiptRequestStatus
                                ? "✅ A receipt will be sent to your email"
                                : "❌ There was a problem sending your receipt"}
                        </StyledFormResponseStatus>
                    )}
                    {receiptRequestStatus === null && (
                        <>
                            <Tab
                                tabs={[
                                    {
                                        key: "enterYourEmail",
                                        text: "📧 Enter your email to get the receipt",
                                    },
                                ]}
                            />
                            <StyledFormWrapper
                                noValidate={true}
                                id="auth"
                                onSubmit={(event) => {
                                    event.preventDefault();
                                    submitEmailForReceipt();
                                }}
                            >
                                <>
                                    <Email setEmail={setEmail} />
                                </>

                                <Button
                                    size="lg"
                                    color="dark-turquoise"
                                    isDisabled={
                                        email !== undefined && email.length < 5
                                    }
                                    onClick={(event) => {
                                        event.preventDefault();
                                        submitEmailForReceipt();
                                    }}
                                    type="submit"
                                    width="100%"
                                    text="Get your receipt"
                                    isLoading={isLoading}
                                />
                            </StyledFormWrapper>
                        </>
                    )}
                </StyledFormContainer>
            </>
        );
    }

    return null;
};
